/** Same colours as the pick route screen, so a green tag means Vleescentrum everywhere. */
export const SHOP_COLORS = { VCE: "green", HVO: "purple" };

/** The shop names as staff say them, for sentences rather than tags. */
export const SHOP_LABELS = { VCE: "Vleescentrum", HVO: "Halalvlees Online" };

export const shopLabel = (shopSource) => SHOP_LABELS[shopSource] || shopSource || "-";
